import { render, staticRenderFns } from "./ShippingHistory.vue?vue&type=template&id=1f224d0c&"
import script from "./ShippingHistory.vue?vue&type=script&lang=js&"
export * from "./ShippingHistory.vue?vue&type=script&lang=js&"
import style0 from "./ShippingHistory.vue?vue&type=style&index=0&id=1f224d0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports